var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"tag loading-tag",class:['loading-tag', 'success-tag', 'error-tag', 'error-tag'][_vm.row.task_status]},[_vm._v(_vm._s(['上传中', '上传成功', '上传失败', '部分失败'][_vm.row.task_status]))])])
}
var staticRenderFns = []

export { render, staticRenderFns }